module.exports = __webpack_public_path__ + "img/zoom-close.3e941852.svg";